import React from 'react';
import HeadingIcon from '../../../assets/heading-tool.png';

interface IHeadingTool {
  currentState: {
    blockType: string;
  };
  onChange: (blockType: string) => void;
}

const HEADING_BLOCK_TYPE = 'H3';

export const HeadingTool: React.FC<IHeadingTool> = props => {
  const { currentState, onChange } = props;

  const isActive = currentState.blockType === HEADING_BLOCK_TYPE;

  const onToggleHading = () => {
    onChange(HEADING_BLOCK_TYPE);
  };

  return (
    <button
      aria-label="rdw-block-type"
      title="Heading"
      data-testid="heading-tool"
      className={`rdw-option-wrapper text-editor-tool sm-img ${isActive ? 'rdw-option-active' : ''}`}
      onClick={onToggleHading}
    >
      <img src={HeadingIcon as string} alt="Heading tool" />
    </button>
  );
};
